import { render, staticRenderFns } from "./TaxInputs.vue?vue&type=template&id=7457cb99&scoped=true"
import script from "./TaxInputs.vue?vue&type=script&lang=js"
export * from "./TaxInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7457cb99",
  null
  
)

export default component.exports